import React, { FC, ReactElement } from 'react';
import { Heading } from 'grommet';

export const LogoFooter: FC = (): ReactElement => (
  <Heading margin={{ top: `0`, bottom: `25px` }} level={1}>
    pentester
  </Heading>
);
